import React from "react";
import { useSearchParams } from "next/navigation";
import ClearSearchFilters from "/app/_components/atoms/search/clear-search-filter/clear-search-filters";
import { CheckboxGroup, ICheckboxGroup, IOption, useQueryFacets } from "@into-discovery/browsewebshared";
import { useFacets } from "../../../../../hooks/use-facets.hook";

type Props = {
  filters: ICheckboxGroup[];
};

export default function SearchFiltersDesktop({ filters = [] }: Props) {
  const searchParams = useSearchParams();
  const queryFacets = useQueryFacets(searchParams);

  const [filtersToDisplay] = useFacets(filters);

  const onChangeCheckbox = (option: IOption, filter: ICheckboxGroup) => {
    if (option.selected) {
      queryFacets.addFacetTerm(filter.id, `"${option.id}"`);
    } else {
      queryFacets.removeFacetTerm(filter.id, option.id);
    }
  };

  return filters?.length === 0 ? null : (
    <>
      <div className="d-lg-flex justify-content-between ">
        <h4 className="mb-0 font-family-lato">Filter by</h4>
        <ClearSearchFilters displayText="Clear all" />
      </div>
      <hr />
      <div className="facets-container">
        {filtersToDisplay.map((filter: ICheckboxGroup) => (
          <CheckboxGroup key={filter.name} filter={filter} onChangeCheckbox={onChangeCheckbox} />
        ))}
      </div>
    </>
  );
}
